import { render, staticRenderFns } from "./ProductEditView.vue?vue&type=template&id=48a2bd9e"
import script from "./ProductEditView.vue?vue&type=script&lang=js"
export * from "./ProductEditView.vue?vue&type=script&lang=js"
import style0 from "./ProductEditView.vue?vue&type=style&index=0&id=48a2bd9e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports